var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentTopSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1568_1232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 0.909058H4.21875C4.09443 0.909058 3.9752 0.956947 3.88729 1.04219C3.79939 1.12743 3.75 1.24305 3.75 1.3636C3.75 1.48416 3.79939 1.59977 3.88729 1.68502C3.9752 1.77026 4.09443 1.81815 4.21875 1.81815H10.7812C10.9056 1.81815 11.0248 1.77026 11.1127 1.68502C11.2006 1.59977 11.25 1.48416 11.25 1.3636C11.25 1.24305 11.2006 1.12743 11.1127 1.04219C11.0248 0.956947 10.9056 0.909058 10.7812 0.909058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83151 2.86038C7.7436 2.77517 7.62439 2.72729 7.5001 2.72729C7.3758 2.72729 7.2566 2.77517 7.16869 2.86038L4.35619 5.58765C4.27081 5.67338 4.22356 5.7882 4.22463 5.90738C4.2257 6.02656 4.27499 6.14057 4.3619 6.22484C4.44881 6.30912 4.56638 6.35692 4.68929 6.35796C4.81219 6.35899 4.9306 6.31318 5.01901 6.23038L7.03135 4.27902V13.1817C7.03135 13.3023 7.08074 13.4179 7.16864 13.5032C7.25655 13.5884 7.37578 13.6363 7.5001 13.6363C7.62442 13.6363 7.74365 13.5884 7.83156 13.5032C7.91946 13.4179 7.96885 13.3023 7.96885 13.1817V4.27902L9.98119 6.23038C10.0696 6.31318 10.188 6.35899 10.3109 6.35796C10.4338 6.35692 10.5514 6.30912 10.6383 6.22484C10.7252 6.14057 10.7745 6.02656 10.7756 5.90738C10.7766 5.7882 10.7294 5.67338 10.644 5.58765L7.83151 2.86038Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1568_1232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentTopSmall);
export default __webpack_public_path__ + "static/media/alignment-top-small.261f19243f2b321b32b5e36db4591d62.svg";
export { ForwardRef as ReactComponent };